export const DYED_UNDYED_DEBOUNCE_MS = 600;
export const COUNTER_ACCENT = '#F06548';
export const COUNTER_HIGHLIGHT_BG = `${COUNTER_ACCENT}2E`;
export const SAME_VALUE_COLOR = '#212529';

export const EMPTY_COUNTER_FORM = {
  deliveryBasis: '',
  incotermId: '',
  incotermPortType: '',
  incotermMultiPortType: '',
  incotermRouteId: '',
  incotermRouteLabel: '',
  incotermFOB: [],
  incotermLocationId: '',
  incotermLocation2Id: '',
  incotermLocation3Id: '',
  quantityLocation1: '',
  quantityLocation2: '',
  quantityLocation3: '',
  startDate: '',
  endDate: '',
  startDate2: '',
  endDate2: '',
  startDate3: '',
  endDate3: '',
  timelineType: null,
  timelineType2: null,
  timelineType3: null,
  loc1Draft1: null,
  loc1Draft2: null,
  loc1Loa1: null,
  loc1Loa2: null,
  loc1Dwt1: null,
  loc1Dwt2: null,
  loc1NotesForSTS: null,
  loc2Draft1: null,
  loc2Draft2: null,
  loc2Loa1: null,
  loc2Loa2: null,
  loc2Dwt1: null,
  loc2Dwt2: null,
  loc2NotesForSTS: null,
  loc3Draft1: null,
  loc3Draft2: null,
  loc3Loa1: null,
  loc3Loa2: null,
  loc3Dwt1: null,
  loc3Dwt2: null,
  loc3NotesForSTS: null,
  additionalInformation: null,
  quantityInformationDetailId: null,
  quantityIncotermId: null,
  selectedRatios: [],
};
